(function () {
  'use strict';

  /* @ngdoc object
   * @name postponements.newPostponement
   * @description
   *
   */
  angular
    .module('neo.home.postponements.new', [
      'ui.router'
    ]);
}());
